/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Classification_SuccessInputs */

const en_doc_classification_success = /** @type {(inputs: Doc_Classification_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document classified`)
};

const pt_br2_doc_classification_success = /** @type {(inputs: Doc_Classification_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento classificado`)
};

/**
* | output |
* | --- |
* | "Document classified" |
*
* @param {Doc_Classification_SuccessInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_classification_success = /** @type {((inputs?: Doc_Classification_SuccessInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Classification_SuccessInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_classification_success(inputs)
	return pt_br2_doc_classification_success(inputs)
});